import type { MaybeRefOrGetter } from "vue";

import { serializeSchemaGraph } from "~/utils/serializeSchemaGraph";

/**
 * Emit one connected schema.org `@graph` per page.
 *
 * Prefer this over multiple disconnected `application/ld+json` scripts so every
 * node can reference others by stable `@id` (Organization, WebSite, maker, menu,
 * product, breadcrumbs) without duplicating islands that validators treat as
 * unrelated.
 */
export function useSchemaGraph(
  key: string,
  nodes: MaybeRefOrGetter<ReadonlyArray<Record<string, unknown> | null | undefined>>,
): void {
  useHead({
    script: [
      {
        key,
        type: "application/ld+json",
        innerHTML: computed(() => serializeSchemaGraph(toValue(nodes))),
      },
    ],
  });
}
